import {
  isSdcxDk63DisplayCell,
  isSdcxDk63MatrixUsable,
  isSdcxDk63PhysicalCell,
  LAYOUT_DK63_FN_KEYCODES,
  LAYOUT_DK63_MACHINE_KEYCODES,
  resolveSdcxDk63MatrixIndex,
  SDCX_DK63_FACTORY_MATRIX_BYTES,
  SDCX_DK63_FN_FACTORY_MATRIX_BYTES,
  SDCX_DK63_MATRIX_COLS,
  SDCX_DK63_MATRIX_LAYER_SIZE,
  SDCX_DK63_MATRIX_ROWS,
  SDCX_DK63_MATRIX_SIZE,
} from "./sdcxDk63MachineLayout";
import type { SdcxMatrixCell } from "./sdcxKeyEncode";
import { isSdcxKeyboardType, type SdcxKeyboardType } from "./sdcxKeyboardTypes";

export type SdcxLayoutProfile = {
  keyboardType: SdcxKeyboardType;
  factoryMatrixBytes: Uint8Array;
  fnFactoryMatrixBytes: Uint8Array;
  layoutKeycodes: number[][];
  fnLayoutKeycodes: number[][];
  matrixRows: number;
  matrixCols: number;
  matrixSize: number;
  layerSize: number;
  isPhysicalCell: (row: number, col: number) => boolean;
  isDisplayCell: (row: number, col: number, cell: SdcxMatrixCell) => boolean;
  isMatrixUsable: (matrix: Uint8Array) => boolean;
  resolveMatrixIndex: (row: number, col: number) => number | null;
};

const SDCX_DK63_MACHINE_PROFILE: SdcxLayoutProfile = {
  keyboardType: "dk63Machine",
  factoryMatrixBytes: SDCX_DK63_FACTORY_MATRIX_BYTES,
  fnFactoryMatrixBytes: SDCX_DK63_FN_FACTORY_MATRIX_BYTES,
  layoutKeycodes: LAYOUT_DK63_MACHINE_KEYCODES,
  fnLayoutKeycodes: LAYOUT_DK63_FN_KEYCODES,
  matrixRows: SDCX_DK63_MATRIX_ROWS,
  matrixCols: SDCX_DK63_MATRIX_COLS,
  matrixSize: SDCX_DK63_MATRIX_SIZE,
  layerSize: SDCX_DK63_MATRIX_LAYER_SIZE,
  isPhysicalCell: isSdcxDk63PhysicalCell,
  isDisplayCell: isSdcxDk63DisplayCell,
  isMatrixUsable: isSdcxDk63MatrixUsable,
  resolveMatrixIndex: resolveSdcxDk63MatrixIndex,
};

/** 按 keyboardType 解析 SDCX 布局配置 */
export function resolveSdcxLayoutProfile(
  keyboardType?: string | null
): SdcxLayoutProfile {
  if (isSdcxKeyboardType(keyboardType)) {
    return SDCX_DK63_MACHINE_PROFILE;
  }
  return SDCX_DK63_MACHINE_PROFILE;
}
